

















import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonDialog from '../organisms/CommonDialog.vue';
import { dayjs, D_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { Teacher } from '../../../src_server/entity/generated/Teacher';
import SimpleSelect from '../../components/inputs/SimpleSelect.vue';
import { MessageDialog } from '../../utils/MessageDialog';
@Component({
  components: { CommonDialog, SimpleSelect },
  filters: {
    dateFormat: (dt: Date) => {
      return dayjs(dt).format(D_FORMAT_JA);
    },
  },
})
export default class CourseSelectDialog extends Vue {
  private teachers: Teacher[] = [];
  private selectedCourses = ''; //: Teacher[] = [];

  get teacherOptions() {
    return this.teachers.map((t) => {
      return { title: t.nickname, value: t.user_id };
    });
  }

  public show(courses: Teacher[], selectedCourses: string[]) {
    this.teachers = courses;
    this.selectedCourses = selectedCourses.join(',');
    (this.$refs['course-dialog'] as CommonDialog).show();
  }

  async selectCourse() {
    this.$emit('selected-course', this.selectedCourses.split(','));
    await MessageDialog.alert('コースを選択しました。更新ボタンで保存してください');
    this.hide();
  }

  public hide() {
    (this.$refs['course-dialog'] as CommonDialog).hide();
  }
}
